<template>
	<div id="header-wp">
		<div id="header">
			<div class="header-1">
				<div class="container">
					<div class="logo" @click="logoIndex()">
						<img :src="icoURL+'storage/'+settingObj.logo" alt="">
					</div>
				</div>
			</div>
			<div class="nav-wp">
				<div class="container">
					<div class="nav">
						<div class="nav_cai"></div>
						<ul class="list-unstyled">
							<li v-for="(item,index) in menus.slice(0,7)" :key="index" 
							:class="{ cur : item.id == hcurIDprop }"
							 :id='`li-${item.id}`' @mouseenter="li_fun(item.id,index)" @mouseleave="li_funx(item.id)"
							>
								<div class="nav_a" @click="navTo(item,index)">{{item.name}}</div>
								<ul class="list-unstyled" v-if="item.child.length > 0 && item.name != '分支机构'">
									<li v-for="(itemx,index) in item.child" :key="index"><div class="nav_axia"@click="navTo(item,itemx,index)">{{itemx.name}}</div></li>
								</ul>
							</li>
						</ul>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</div>
		<div id="header-2">
			<div class="logo-2 fl" @click="logoIndex()">
				<img :src="icoURL+'storage/'+settingObj.logo" alt="">
			</div>
			<div class="menu2 fr">
				<ul class="list-unstyled">
					<li><a id="sanlan"><img src="../assets/images/sanlan.png" alt=""></a></li>
				</ul>
				<div class="clear"></div>
			</div>
			<div class="clear"></div>
			<div class="nav-2">
				<ul class="list-unstyled">
				<!--<li><a href="#">公司概况</a>
						<span class="jiaspan"></span>
						<ul class="list-unstyled">
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
							<li><a href="#">二级栏目</a></li>
						</ul>
					</li> -->
					<li v-for="(item,index) in this.menus.slice(0,7)">
						<div class="nav_ax" @click="navTo(item,index)">{{item.name}}</div>
						<template v-if="item.child.length > 0 && item.name != '分支机构'">
							<span :id='`jiaspan-${item.id}`' class="jiaspan" @click="jiaspan_fun(item.id)"></span>
							<ul class="list-unstyled">
								<li v-for="itemx in item.child">
									<div class="nav_axx" @click="navTo(item,itemx,index)">{{itemx.name}}</div>
								</li>
							</ul>
						</template>
					</li>
				</ul>
			</div>
		</div>
		<div class="chenggao"></div>
		<div id="nav-2-heidi"></div>
	</div>
</template>

<script>
	export default{
		name:'hmenu',
		props:['hcurID'],
		data(){
			return{
				menus:[],
				hcurIDprop:'',
				setting:[],
				settingObj:{
					logo:'',
					title:'',
					description:'',
					keywords:''
				}
			}
		},
		methods:{
			res_menu(){
				this.axios.get('/api/menus')
					.then(response => {
						// 处理成功情况
						console.log('栏目查询:',response);
						if(response.data.code == 200){
							this.menus = response.data.reslut;
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
				
			},
			res_menuClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							if(this.settingObj.title != ''){
								document.title = response.data.reslut.name + '-' + this.settingObj.title;
							}
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
				
			},
			logoIndex(){
				this.$router.push('/');
				$("#nav-2-heidi").fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
				$('html, body').animate({ scrollTop: 0 }, 0);
			},
			phoneMenu(){
				$("#nav-2-heidi").fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
				$(".nav>ul>li>ul").hide();
				$('html, body').animate({ scrollTop: 0 }, 0);
			},
			li_fun(e,p){
				let id = `li-${e}`;
				let dom = $(`#${id}`);
				dom.find("ul").stop(false,true).slideDown();
				$('.nav_cai').stop().animate({
					'left': (p*14.28571)+'%'
				}, 200, 'linear')
			},
			li_funx(e){
				let id = `li-${e}`;
				let dom = $(`#${id}`);
				dom.find("ul").stop(false,true).hide();
			},
			jiaspan_fun(e){
				let id = `jiaspan-${e}`;
				var dom = $(`#${id}`);
				if(dom.hasClass("cur")){
					dom.removeClass("cur");
					$(".nav-2>ul>li>ul").slideUp();
				}else{
					$(".jiaspan").removeClass("cur");
					dom.addClass("cur");
					$(".nav-2>ul>li>ul").slideUp();
					dom.next(".nav-2>ul>li>ul").slideDown();
				}
			},
			navTo(item,itemx,index){
					// this.phoneMenu();
					this.navFun(item,itemx,index);
					// this.hcurIDprop = item.id;
			},
			navFun(item,itemx,index){
				// console.log('关于我们',this.$route,item)
				
				//特殊页面跳转
				/*
					资质展示:/aptitude;
					联系我们:/contactus;
					列表类:/elist
					特殊列表(一三九通讯):/communication;
					专家库:/specialist
					招聘:/join
					分支机构:/branch
					
				*/
				
				this.phoneMenu();
				
				
				if(item.name == '首页'){
					this.$router.push({
						path:'/',
					})
				}
				if(item.name == '关于我们' || item.name == '业务领域' || item.name == '企业文化'){
					this.$router.push({
						path:'/slider/' + item.id + '/single',
						query:{
							category_id:item.child[0].id
						}
					})
				}
				if(item.name == '新闻中心' || item.name == '成果荣誉'){
					this.$router.push({
						path:'/slider/'+ item.id + '/elist',
						query:{
							category_id:item.child[0].id
						}
					})
				}
				if(itemx.name == '文化动态'){
					this.$router.push({
						path:'/slider/'+ item.id + '/elist',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(item.name == '人力资源'){
					this.$router.push({
						path:'/slider/'+ item.id + '/join',
						query:{
							category_id:item.child[0].id
						}
					})
				}
				if(item.name == '分支机构'){
					this.$router.push({
						path:'/slider/'+ item.id + '/branch',
						query:{
							category_id:item.child[0].id
						}
					})
				}
				if(itemx.name == '资质展示'){
					
					this.$router.push({
						path:'/slider/'+ item.id + '/aptitude',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '联系我们'){
					this.$router.push({
						path:'/slider/'+ item.id + '/contactus',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '专家库'){
					this.$router.push({
						path:'/slider/'+ item.id + '/specialist',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '人才招聘'){
					this.$router.push({
						path:'/slider/'+ item.id + '/join',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '一三九通讯'){
					this.$router.push({
						path:'/slider/'+ item.id + '/communication',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '公司新闻' || itemx.name == '地勘成果' || itemx.name == '公司荣誉'){
					this.$router.push({
						path:'/slider/'+ item.id + '/elist',
						query:{
							category_id:itemx.id
						}
					})
				}
				if(itemx.name == '企业文化' || itemx.name == '公司简介' || itemx.name == '组织架构' || itemx.name == '领导集体' || itemx.name == '地质勘查' || itemx.name == '测绘工作' || itemx.name == '地质灾害预防' || itemx.name == '新能源开发'){
					this.$router.push({
						path:'/slider/'+ item.id + '/single',
						query:{
							category_id:itemx.id
						}
					})
				}
				
			},
			res_setting(){
				this.axios.get('/api/setting')
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.setting = response.data.reslut;
							this.setting.forEach(item=>{
								if(item.key == "xsjgw.logo"){
									this.settingObj.logo = item.value;
								}
								if(item.key == "xsjgw.title"){
									this.settingObj.title = item.value;
								}
								if(item.key == "xsjgw.description"){
									this.settingObj.description = item.value;
								}
								if(item.key == "xsjgw.keywords"){
									this.settingObj.keywords = item.value;
								}
							}) 
							if(this.settingObj.keywords != ''){
								$("meta[name='Keywords']").eq(0).attr("content",this.settingObj.keywords)
							}
							if(this.settingObj.description != ''){
								$("meta[name='Description']").eq(0).attr("content",this.settingObj.description)
							}	
								
								
							if(this.hcurIDprop){
								this.res_menuClass(this.hcurIDprop);
							}else{
								if(this.settingObj.title != ''){
									document.title = this.$route.query.name + '-' + this.settingObj.title;
								}
							}
						}
						
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
		},
		created() {
			this.hcurIDprop = this.hcurID;
			this.res_menu();
			this.res_setting();
			// this.res_siteInfo();
		},
		watch :{
			'hcurID' (to, from) {
					// 对路由变化作出响应...
					console.log('this.$route',this.$route)
					this.hcurIDprop = this.hcurID;
					if(this.hcurIDprop){
						this.res_menuClass(this.hcurIDprop);
					}else{
						if(this.settingObj.title != ''){
							
							document.title = this.$route.query.name + '-' + this.settingObj.title;
						}
					}
			}
		},
		mounted(){
			$("#sanlan").click(function(){
				$("#nav-2-heidi").fadeToggle();
				$(".nav-2").slideToggle();
				$(".nav-2>ul>li>ul").slideUp();
				$(".jiaspan").removeClass("cur");
				console.log("ojbk00")
			})
			$("#nav-2-heidi").click(function(){
				$(this).fadeOut();
				$(".nav-2>ul>li>ul").slideUp();
				$(".nav-2").slideUp();
			})
		}
	}
</script>

<style>
</style>